/**
 * @file
 * @author dailin01
 */
import Button from './button';
export { ButtonProps } from './button';
export default Button;
